import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IClient, IClientRes, IClientResA } from 'app/interfaces/client';
import { IBookDiscountRes, IBookDiscountResA, IPetitionQuantityBundleResA, IPetitionQuantityResA } from 'app/interfaces/petitions.interface';
import { IVoucherRes } from 'app/interfaces/voucher.interface';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClientService {
  API_URL = environment.apiUrl;
  route = '/clients';
  route_cb = '/client-book'

  constructor(
    private http: HttpClient
  ) { }

  getQuantityById(id: any): Observable<IPetitionQuantityResA> {
    return this.http.get<IPetitionQuantityResA>(`${this.API_URL}/clients-requests/${id}`, {});
  }
  
  getBooksDiscount(id: any): Observable<IBookDiscountResA> {
    return this.http.get<IBookDiscountResA>(`${this.API_URL}${this.route_cb}-discount/${id}`, {});
  }
  
  deleteBookDiscount(id: any): Observable<IBookDiscountRes> {
    return this.http.delete<IBookDiscountRes>(`${this.API_URL}${this.route_cb}-discount/${id}`, {});
  }

  addBookDiscount(data: any): Observable<IBookDiscountRes> {
    return this.http.post<IBookDiscountRes>(`${this.API_URL}${this.route_cb}-discount/single`, {
    ...data
    });
  }

  addBundleDiscount(data: any): Observable<any> {
    return this.http.put<any>(`${this.API_URL}/client-bundles/discount`, {
    ...data
    });
  }

	storeDiscountBookByExcel(data: any): Observable<any> {
		const fd = new FormData();
		Object.keys(data).forEach(key => {
			if (key === 'file') {
				fd.append(key, data[key]);
			} else {
				fd.append(key, data[key]);
			}
		});
		//console.log("fd", fd)
		return this.http.post<any>(`${this.API_URL}${this.route_cb}/discount/excel`, fd);
	}

  get(id?: any): Observable<IClientResA> {
    return this.http.get<IClientResA>(`${this.API_URL}${this.route}`, {});
  }

  getClientsByDistributor(id: any): Observable<IClientResA> {
    return this.http.get<IClientResA>(`${this.API_URL}/distributors${this.route}/${id}`, {});
  }

  show(id: number): Observable<IClientRes> {
    return this.http.get<IClientRes>(`${this.API_URL}${this.route}/${id}`, {});
  }
  
  checkClient(): Observable<IClientRes> {
    return this.http.get<IClientRes>(`${this.API_URL}${this.route}-search`, {});
  }

  store(data: IClient): Observable<IClientRes> {
    return this.http.post<IClientRes>(`${this.API_URL}${this.route}`, {
    ...data
    });
  }

  delete(id: number): Observable<IClientRes> {
    return this.http.delete<IClientRes>(`${this.API_URL}${this.route}/${id}`, {});
  }

  update(data: IClient): Observable<IClientRes> {
    return this.http.put<IClientRes>(`${this.API_URL}${this.route}/${data.id}`, {
    ...data
    });
  }

  getReceiptsByClient(id: any): Observable<IClientRes> {
    return this.http.get<IClientRes>(`${this.API_URL}${this.route}/show-receipts/${id}`, {});
  }

  showReceipt(id: any): Observable<IVoucherRes> {
    return this.http.get<IVoucherRes>(`${this.API_URL}${this.route}/receipt/${id}`, {});
  }

  uploadReceipt(id: any,data: any): Observable<IVoucherRes> {
    const fd = new FormData();
    Object.keys(data).forEach(key => {
      if (key === 'transfer_receipt') {
        fd.append(key, data[key]);
      } else {
        fd.append(key, data[key]);
      }
    });
      //console.log("fd", fd)
      return this.http.post<IVoucherRes>(`${this.API_URL}${this.route}/upload-receipt/${id}`, fd);
  }
  
  getStateAccountByBundle(id: any): Observable<IPetitionQuantityBundleResA> {
    return this.http.get<IPetitionQuantityBundleResA>(`${this.API_URL}/client-bundles/requests/${id}`, {});
  }
}

